/*
 * @Author: hujingyang
 * @Date: 2021-01-19 10:26:07
 * @Description: 生成短链接
 * @LastEditors: yang chenglin
 * @LastEditTime: 2021-04-23 15:54:25
 * @FilePath: \DouYinStore\src\pages\OrderSelection\components\Dialog_GenerateShortURL\index.tsx
 * @IDE: Created by VScode.
 */


import React, { useEffect, useState } from 'react';
import { Button, Dialog, Input, Message } from '@alifd/next';
import style from './index.module.scss';
import copy from 'copy-to-clipboard';
import { Servlets } from '@/service';
import utils from '@/common/utils';

/** 生成短链接弹窗 */
const Dialog_GenerateShortURL = (props: any): JSX.Element => {
  const [visible, setVisible] = useState(false);// 是否打开弹窗
  const [url, setUrl] = useState('');// 长链接
  const [shortUrl, setShortUrl] = useState('');// 短链接

  /** 生命周期函数 */
  useEffect(() => {
    init();
  }, [props]);

  /** 初始化函数
   *
   */
  const init = (): void => {
    getPageData();
    setVisible(props.visible);
  };
  /** 获取页面 */
  const getPageData = (): void => {

  };
  /** 重置页面数据 */
  const reSetPageData = (): void => {
    setVisible(false);// 关闭弹窗
    setUrl('');// 清空长链接数据
    setShortUrl('');// 清空短链接数据
  };

  /** 关闭弹窗触发 */
  const onClose = (): void => {
    props.selected(false);

    // 重置页面数据
    reSetPageData();
  };
  /** 输入框键盘事件 */
  const onKeyup = (e: { keyCode: number }): void => {
    if (e.keyCode === 13) { // 监听回车键
      handleChangeShortURL();
    }
  };
  /** 转化为短链接 */
  const handleChangeShortURL = (): void => {
    if (!url) {
      // 这里给出提示
      Message.notice('请输入长链接后转换');
      return;
    }
    Servlets('createShortLink', { url }).then((res: { data: string }) => {
      setShortUrl(` ${res.data} `);

      // 将长短链接返回至父组件
      if (props.getUrl !== undefined) props.getUrl({ longUrl: url, shortUrl: `${res.data}` });
    });
  };
  /** 输入长链接 */
  const handleChangeSetUrl = (val: string): void => {
    setUrl(val);
  };
  /** 将生成的短链接复制至粘贴板 */
  const handleClickCopyUse = (): void => {
    console.log(shortUrl,'shortUrl');
    // copy(shortUrl);
    // Message.success('短链接已复制');
  };

  /** 函数防抖 响应函数 */
  const responseFunc = (func, ...argu) => {
    utils.debounceImmediately(func)(argu); // 立即执行
  };

  return (
    <>
      <section>
        <Dialog
          className="generateShortURL"
          title="短链接生成"
          visible={visible}
          footer={[<Button
            key="cancel"
            onClick={onClose}
            className={`${style.submitBtnStyle_width} ${style.submitBtnStyle_marginRight}`}
          >取消
          </Button>,
            <Button
              type="primary"
              className={`${style.submitBtnStyle_width} ${style.submitBtnStyle_marginRight}`}
              key="submit"
              onClick={() => {
                handleClickCopyUse();
                onClose();
              }}
            >复制链接使用
            </Button>]}
          onClose={onClose}
        >
          <div style={{ marginBottom: '25px' }}>
            <span>输入长链接：</span>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
              <Input
                value={url}
                trim
                placeholder="请输入需要转换的长链接"
                onKeyUp={onKeyup}
                onChange={handleChangeSetUrl}
                style={{ marginRight: '14px', width: '614px' }}
                hasClear
              />
              <Button
                type="primary"
                text
                onClick={() => responseFunc(handleChangeShortURL)}
              >转化通用短链
              </Button>
            </div>

          </div>

          <div>
            <span>短链接结果：</span>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
              <Input disabled value={shortUrl} style={{ marginRight: '14px', width: '614px' }} />

              {/* <Button type="primary" text onClick={handleClickCopyUse}>复制链接使用</Button> */}
            </div>

          </div>
        </Dialog>
      </section>

    </>
  );
};

export default Dialog_GenerateShortURL;
